import useResize from "../../../hooks/useResize"
export type SizePagination = "small" | "medium" | "large"
export const useSizeOfPagination = (): SizePagination => {
  const screenWidth = useResize()
  if (screenWidth < 768) return "small"
  if (screenWidth > 768 && screenWidth < 1024) return "medium"
  return "large"
}
